import DOMPurify from "dompurify";

// Renders admin-authored rich text (HTML) safely. Falls back to plain text.
// Inline colours authored in the CMS override the site text colour because
// they are applied as inline styles (which win over the inherited CSS var).
export const RichText = ({ html, as: Tag = "div", className = "", testid }) => {
  const clean = DOMPurify.sanitize(html || "", { ADD_ATTR: ["target", "rel"] });
  return (
    <Tag
      data-testid={testid}
      className={className}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};
